import {useContext, useState} from 'react'

import styles from './dropdown.module.css'

const Dropdown = (props) => {
    const { options, defaultValue, disabled, onChange } = props
    const [open, setOpen] = useState(false)
    const [selectedValue, setSelectedValue] = useState(defaultValue)

    const handleSelect = (option) => {
        setSelectedValue(option)
        setOpen(false)
        onChange(option)
    }
    return (
        <div className={styles.dropdown}>
            <div
                className={`selected text-option ${disabled ? 'disabled' : ''} ${
                    open ? 'open' : ''
                }`}
                onClick={() => !disabled && setOpen((prev) => !prev)}
            >
                {selectedValue}

            </div>
            {open ? (
                <>
                        <div className="dropdown-items">
                        {options?.map((option, index) => (
                            <div className="item text-option" onClick={() => handleSelect(option)}>
                                {option}
                            </div>

                        ))}


                    </div>

                    <div className="blank" onClick={() => setOpen(false)} />


                </>
            ) : (
                <></>
            )}
        </div>
    )
}

export default Dropdown
